import React from 'react'
import {Row,Col,Tag,Input} from 'antd'
import {withNamespaces} from 'react-i18next'
import ContentList from './ContentList'
import * as API from './API'
import './cms.css'
import * as CacheUtil from '../util/CacheUtil'

//const TYPE = 'Post'
const Q_NAME = 'latest-posts'
const _UPDATED = '_updated'

class Home extends React.Component {
  state={contents:{}}
  componentDidMount() {
    this.setup()
  }
  setup() {
    /*this.fetchContents(TYPE, ()=>{
      const {contents} = this.state
      if (typeof(contents)==='object'&&contents!==null) {
        const list = contents[TYPE].sort((a,b)=>{
          return b.created-a.created
        })
        this.setState({list})
      }
    }, this.cbe)*/
    //this.fetchQueue(Q_NAME, 0)
    this.fetchUpdated(()=>{
      this.initList()
    })
  }
  cbe=e=>{
    if (e) {
      this.setState((prevState,props)=>{
        const {err} = prevState
        if (Array.isArray(err)) {
          err.push(e)
          return {err}
        }
        return {err:[e]}
      })
    }
  }
  fetchAggregates(cb) {
    API.aggregates(data=>{
      this.setState({aggregates:data},cb)
    }, this.cbe)
  }
  fetchContents(type,cb) {
    API.contents(type,data=>{
      this.setState((prevState,props)=>{
        const {contents} = prevState
        if (typeof(contents)==='object'&&contents!==null) {
          contents[type] = data
          return {contents}
        }
        const tmp = {}
        tmp[type] = data
        return {contents:tmp}
      },cb)
    }, this.cbe)
  }
  fetchQueue(name,page,cb) {
    API.queue(name,page,cb,this.cbe)
  }
  fetchUpdated(cb) {
    API.text(_UPDATED,text=>{
      if (typeof(text)==='string'&&text.length>0) {
        const updated = parseInt(text,10)
        if (typeof(updated)==='number') {
          const lastUpdated = CacheUtil.get(_UPDATED)
          if (lastUpdated===undefined||lastUpdated!==updated) {
            CacheUtil.remove(Q_NAME)
            CacheUtil.remove(_UPDATED)
            CacheUtil.set(_UPDATED,updated)
          }
          if (typeof(cb)==='function') {
            cb()
          }
        }
      }
    }, this.cbe)
  }
  initList(cb) {
    const list = CacheUtil.get(Q_NAME)
    if (Array.isArray(list)) {
      this.setState({list},cb)
    } else {
      this.fetchQueue(Q_NAME,0,list=>{
        if (Array.isArray(list)&&list.length>0) {
          CacheUtil.set(Q_NAME,list)
          this.setState({list},cb)
        }
      })
    }
  }
  renderHeader() {
    return null
  }
  renderNavigator() {
    const {t} = this.props
    return (
      <Row className="cms-navigator">
        <Col span={4}>
        </Col>
        <Col span={16}>
          <h1 className="text-center content-title text-shadow">{t('key:home')}</h1>
        </Col>
        <Col span={4}>
        </Col>
      </Row>
    )
  }
  handleOnTag=e=>{
    if (typeof(e)==='object'&&e!==null) {
      this.setState((prevState,props)=>{
        const {tags} = prevState
        if (Array.isArray(tags)) {
          const {_id} = e
          if (tags.findIndex(e=>e._id===_id)<0) {
            tags.push(e)
            return tags
          }
        } else {
          return {tags:[e]}
        }
        return null
      })
    }
  }
  handleRemove=tag=>{
    if (typeof(tag)==='object'&&tag!==null) {
      this.setState((prevState,props)=>{
        const {tags} = prevState
        if (Array.isArray(tags)&&tags.length>0) {
          const {_id} = tag
          return {tags:tags.filter(e=>e._id!==_id)}
          /*const index = tags.findIndex(e=>e._id===_id)
          if (index>=0) {
            tags.splice(index, 1)
            return {tags}
          }*/
        }
        return null
      })
    }
  }
  renderTags() {
    const {tags} = this.state
    if (Array.isArray(tags)&&tags.length>0) {
      return (
        <div className="mb-3 content-tags">
          {
            tags.map((e,i)=>{
              const {name} = e
              return (
                <Tag key={i} color="geekblue" className="mr-1 mb-1" closable={true} onClick={()=>this.handleRemove(e)}>{name}</Tag>
              )
            })
          }
        </div>
      )
    }
    return null
  }
  handleSearch=event=>{
    this.onSearch(event.target.value)
  }
  onSearch=keyword=>{
    if (typeof(keyword)==='string') {
      this.setState({keyword})
    }
  }
  renderForm() {
    const {t} = this.props
    return (
      <div className="content-form mb-5">
        <Input.Search placeholder={t('key:search')} onSearch={this.onSearch} onChange={this.handleSearch} className="mb-2 search-box" size="large" />
        {this.renderTags()}
        {/*<pre><code>{JSON.stringify(this.state.tags,null,2)}</code></pre>*/}
        {/*
          <pre><code>{this.state.keyword}</code></pre>
        */}
      </div>
    )
  }
  render() {
    const {t} = this.props
    const {list,tags,keyword} = this.state
    let filtered = list
    if (Array.isArray(filtered)&&filtered.length>0) {
      if (Array.isArray(tags)&&tags.length>0) {
        filtered = filtered.filter(e=>{
          if (Array.isArray(e.tags)&&e.tags.length>0) {
            /*return e.tags.findIndex(e=>{
              const {_id} = e
              return tags.findIndex(e=>e._id===_id)>=0
            })>=0*/
            for (let i in tags) {
              const tag = tags[i]
              const {_id} = tag
              if (e.tags.findIndex(e=>e._id===_id)<0) return false
            }
            return true
          }
          return false
        })
      }
      if (typeof(keyword)==='string'&&keyword.length>0) {
        filtered = filtered.filter(e=>{
          const {name,lead,body} = e
          const k = keyword.toLowerCase()
          if (typeof(name)==='string'&&name.length>0) {
            if (name.toLowerCase().indexOf(k)>=0) {
              return true
            }
          }
          if (typeof(lead)==='string'&&lead.length>0) {
            if (lead.toLowerCase().indexOf(k)>=0) {
              return true
            }
          }
          if (typeof(body)==='string'&&body.length>0) {
            if (body.toLowerCase().indexOf(k)>=0) {
              return true
            }
          }
          return false
        })
      }
    }
    return (
      <div className="mt-6">
        {this.renderHeader()}
        {this.renderNavigator()}
        <div className="cms-container">
          {this.renderForm()}
          <ContentList t={t} list={filtered} onTag={this.handleOnTag} />
          {/*<pre><code>{JSON.stringify(this.state,null,2)}</code></pre>
          <pre><code>{JSON.stringify(err,null,2)}</code></pre>*/}
        </div>
      </div>
    )
  }
}
export default withNamespaces('translations')(Home)
